const INVENTORY_API_URL = "https://t30e7k13cb.execute-api.us-east-1.amazonaws.com/prod/inventory";

export const API_CONFIG = {
  FILTER_API: process.env.REACT_APP_FILTER_API,
  RESUME_API: process.env.REACT_APP_RESUME_API,
  INVENTORY_API: INVENTORY_API_URL,  // Always use hardcoded URL, ignore env var
};
